import env from "$root/env";
import { atomWithReducer, useAtomValue } from "@mdotm/shadcn/legacy/reactivity";
import { maybeCall, type SetterOrUpdaterParam } from "@mdotm/shadcn/legacy/utils";

export type SystemMode = "DEFAULT" | "READONLY" | "MAINTENANCE";
export interface ISystem {
	systemMode: SystemMode;
	serverEnv: string;
	clientEnv: string;
}

export const systemDefaults: ISystem = {
	systemMode: env.featureFlags?.maintenance ? "MAINTENANCE" : "DEFAULT",
	serverEnv: "",
	// `envName` and not `appEnv`: the first is which environment this is, the second is only how the
	// app should behave. Every dynamically created environment shares the behaviour class of a
	// development one, so reporting `appEnv` here would make them all indistinguishable.
	clientEnv: env.envName,
};

export const system$ = atomWithReducer(systemDefaults, (value: ISystem, next: SetterOrUpdaterParam<ISystem>) => {
	return maybeCall(next, value);
});

export function useSystemValue(): ISystem {
	return useAtomValue(system$);
}
